import type { Translate } from 'providers/ApplicationContext';
import { Link } from 'react-router';
import type { AdminDensity } from './useAdminPrefs';

type BulkToggleButtonProps = {
	isBulk: boolean;
	onToggle: () => void;
	t: Translate;
};

export function BulkToggleButton({ isBulk, onToggle, t }: Readonly<BulkToggleButtonProps>) {
	return (
		<button
			aria-pressed={isBulk}
			className={`admin-prefs-btn${isBulk ? ' admin-prefs-btn--active' : ''}`}
			onClick={onToggle}
			title={t('admin_bulk_cancel_title') || 'Bulk cancel processes'}
			type="button"
		>
			✕ {t('admin_bulk_cancel') || 'Bulk cancel'}
		</button>
	);
}

type AdminPrefsBarProps = {
	density: AdminDensity;
	isBulk: boolean;
	onToggleBulk: () => void;
	resultCount: number;
	showGuid: boolean;
	t: Translate;
	toggleDensity: () => void;
	toggleShowGuid: () => void;
	totalCount: number;
};

export function AdminPrefsBar({
	density,
	isBulk,
	onToggleBulk,
	resultCount,
	showGuid,
	t,
	toggleDensity,
	toggleShowGuid,
	totalCount
}: Readonly<AdminPrefsBarProps>) {
	return (
		<div className="admin-prefs-bar">
			<span className="admin-dashboard__result-label">
				{resultCount} / {totalCount}
			</span>
			<div className="admin-prefs-toggles">
				<button
					aria-pressed={density === 'compact'}
					className={`admin-prefs-btn${density === 'compact' ? ' admin-prefs-btn--active' : ''}`}
					onClick={toggleDensity}
					title={
						density === 'compact'
							? t('admin_density_comfortable') || 'Switch to Comfortable'
							: t('admin_density_compact') || 'Switch to Compact'
					}
					type="button"
				>
					{density === 'compact' ? '⊟' : '⊞'}{' '}
					{density === 'compact'
						? t('admin_density_compact') || 'Compact'
						: t('admin_density_comfortable') || 'Comfortable'}
				</button>
				<button
					aria-pressed={showGuid}
					className={`admin-prefs-btn${showGuid ? ' admin-prefs-btn--active' : ''}`}
					onClick={toggleShowGuid}
					title={t('admin_show_guid') || 'Toggle GUID visibility'}
					type="button"
				>
					# {t('admin_guid') || 'GUID'}
				</button>
				<BulkToggleButton isBulk={isBulk} onToggle={onToggleBulk} t={t} />
				<Link
					className="admin-prefs-btn"
					title={t('admin_metrics_title') || 'Completion metrics'}
					to="/admin/completion-metrics"
				>
					📊 {t('admin_metrics_title') || 'Completion metrics'}
				</Link>
			</div>
		</div>
	);
}
